import { actions } from "../../../../../common/constants";

const initialState = {
  isAdminDetailLoaded: false,
  isSubmitting: false,
  admin: {},
  isAdminDetailUpdated: false,

  admins: {},
  isAdminsLoaded: false,
};

const actionMap = {
  [actions.GET_ADMINS_REQUEST]: (state) => ({
    ...state,
    isSubmitting: true,
    isAdminsLoaded: false,
  }),
  [actions.GET_ADMINS_SUCCESS]: (state, { result }) => ({
    ...state,
    isSubmitting: false,
    isAdminsLoaded: true,
    admins: result.data,
  }),
  [actions.GET_ADMINS_FAILURE]: (state) => ({
    ...state,
    isSubmitting: false,
    isAdminsLoaded: false,
  }),

  [actions.GET_ADMIN_SETTING_REQUEST]: (state) => ({
    ...state,
    isSubmitting: true,
    isAdminDetailLoaded: false,
  }),
  [actions.GET_ADMIN_SETTING_SUCCESS]: (state, { result }) => ({
    ...state,
    isSubmitting: false,
    isAdminDetailLoaded: true,
    admin: result.data,
  }),
  [actions.GET_ADMIN_SETTING_FAILURE]: (state) => ({
    ...state,
    isSubmitting: false,
    isAdminDetailLoaded: false,
  }),

  [actions.SET_ADMIN_INFO_REQUEST]: (state) => ({
    ...state,
    isSubmitting: true,
    isAdminDetailUpdated: false,
  }),
  [actions.SET_ADMIN_INFO_SUCCESS]: (state, { result }) => ({
    ...state,
    isSubmitting: false,
    isAdminDetailUpdated: true,
    admin: result.data,
  }),
  [actions.SET_ADMIN_INFO_FAILURE]: (state) => ({
    ...state,
    isSubmitting: false,
    isAdminDetailUpdated: false,
  }),
};

export default (state = initialState, action) => {
  if (actionMap[action.type]) {
    return actionMap[action.type](state, action);
  }

  return state;
};



// WEBPACK FOOTER //
// ./client/react/Admin/store/reducers/admin.js